import { Reducer } from 'redux';
// Helpers
import { oneWeekAgo } from 'helpers/date';
import { ReportsState, ReportsTypes } from './types';

const INITIAL_STATE: ReportsState = {
  chartReportList: [],
  kmByDayReportList: [],
  passengersAndVehiclesReportList: null,
  passengersAndVehiclesByTripReportList: null,
  pedestriansEntryByTerminalList: [],
  timedOutEntriesList: [],
  tripeCollectionReportList: [],
  emvReportList: [],
  emvDeclinedByReasonReportList: [],
  emvApprovedByBrandReportList: [],
  emvApprovedByDebtRecoveryReportList: [],
  emvApprovedByAttemptsReportList: [],
  emvApprovedByFirstTapByBrandReportList: [],
  emvEntryGetList: null,
  emvEntryGetHistoryList: null,
  ordersBySchoolsList: [],
  studentCardsList: [],
  transportedPassengersList: [],
  transportedPassengersByTimeFrameList: [],
  transportedPassengersByTimeFrameByProfileList: [],
  kmDrivedList: [],
  gateEntryReportList: [],
  invoicesList: [],
  invoicesListFull: [],
  passengersByOriginReportList: [],
  superiorAccessReportList: {},
  lineDemandReportList: {
    '': {
      valuePerKm: 0,
      totalValue: 0,
      ipk: 0,
      ipke: 0,
      kvd: 0,
      pvd: 0,
      kpis: {
        ipk: 0,
        ipke: 0,
        valuePerKm: 0,
        kvd: 0,
        pvd: 0,
        trips: 0,
        km: 0,
        idleKm: 0,
      },
      benefits: {},
      benefitsCount: {},
    },
  },
  lineQuantityReportList: {
    '': {
      valuePerKm: 0,
      totalValue: 0,
      ipk: 0,
      ipke: 0,
      kvd: 0,
      pvd: 0,
      kpis: {
        ipk: 0,
        ipke: 0,
        valuePerKm: 0,
        kvd: 0,
        pvd: 0,
        trips: 0,
        km: 0,
        idleKm: 0,
      },
      benefits: {},
      benefitsCount: {},
    },
  },
  dailyDemandReportList: {
    '': {
      totalValue: 0,
      kpis: {
        km: 0,
        idleKm: 0,
        trips: 0,
        cars: 0,
        ipk: 0,
        ipke: 0,
        valuePerKm: 0,
        kvd: 0,
        pvd: 0,
      },
      benefits: {},
      benefitsCount: {},
    },
  },
  dailyQuantityReportList: {
    '': {
      totalValue: 0,
      kpis: {
        km: 0,
        idleKm: 0,
        trips: 0,
        cars: 0,
        ipk: 0,
        ipke: 0,
        valuePerKm: 0,
        kvd: 0,
        pvd: 0,
      },
      benefits: {},
      benefitsCount: {},
    },
  },
  dailyQuantitySeccionedReportList: {
    '': {
      totalValue: 0,
      kpis: {
        km: 0,
        idleKm: 0,
        trips: 0,
        cars: 0,
        ipk: 0,
        ipke: 0,
        valuePerKm: 0,
        kvd: 0,
        pvd: 0,
      },
      benefits: {},
      benefitsCount: {},
    },
  },
  selectedSeccionedLine: null,
  shipmentLineEntries: null,
  chipsListEntry: [],
  chipsListValue: [],
  chipsListLine: [],
  chipsHeatmap: [],
  chipsFleet: [],
  chipsTravel: [],
  chipsPaymentReport: [],
  chartEntryReportList: {
    totalValue: 0,
    data: [],
  },
  chartEntryReportSimplifiedList: [],
  entryReportListGrouped: [],
  heatmapList: [],
  paymentList: [],
  emtuReportList: {
    data: [],
    csv: '',
  },
  generalReportList: [],
  travelByLineReportList: [],
  selectedCarsId: [],
  selectedInvoiceStatus: null,
  selectedCars: [],
  selectedCompanies: [],
  selectedTerminals: [],
  selectedProfiles: [],
  selectedPayments: [],
  selectedQRCodes: [],
  selectedLines: [],
  selectedSchools: [],
  selectedSectionLines: { start: [], end: [] },
  filenameSelected: '',
  selectedEmployees: [],
  selectedDriverRegistry: [],
  selectedReceivePayments: [],
  selectedTripStatus: [],
  selectedTripOrTicket: '',
  selectedSupervisors: [],
  selectedSellingPoint: [],
  selectedSellingTerminal: [],
  selectedDbds: [],
  selectedTokenStatus: null,
  selectedCreditType: [],
  selectedName: '',
  selectedQuantity: null,
  selectedDocument: '',
  selectedEmail: '',
  selectedTransportCard: '',
  selectedDevice: '',
  selectedCreditCard: '',
  selectedCNPJ: '',
  selectedNSU: '',
  selectedPhone: '',
  history: false,
  selectedLicense: '',
  selectedPrefix: '',
  selectedCarModel: '',
  selectedAge: '',
  selectedSitCapacity: '',
  selectedFootCapacity: '',
  selectedRegistry: '',
  selectedLicenseNumber: '',
  selectedNumber: '',
  selectedCardNumber: '',
  selectedLot: '',
  selectedTitle: '',
  selectedLineModes: null,
  selectedLineModel: null,
  selectedCardType: null,
  selectedCardStatus: null,
  selectedCovered: null,
  selectedBusBay: null,
  selectedSpecialBusStop: null,
  selectedResponsible: '',
  selectedTerminalName: '',
  selectedBlockName: '',
  selectedTotalLines: null,
  selectedTariff: null,
  selectedAccessible: null,
  selectedAirConditioned: null,
  selectedTicketer: null,
  selectedProfileStatus: null,
  selectedStatus: null,
  selectedPaymentStatus: [],
  selectedOperationType: [],
  filterItems: [],
  csvFullIsChecked: false,
  selectedStartDate: new Date(new Date().setHours(0, 0, 0)),
  selectedEndDate: new Date(new Date().setHours(23, 59, 59)),
  startedAt: new Date(),
  selectedProfileExpiration: new Date(),
  numberOfDays: 0,
  totalCount: 0,
  error: false,
  loading: false,
  dateType: 'created',
  dateTypeBPe: 'emission',
  lineType: 'fullLine',
  statusDeviceRelease: null,
  scheduleList: [],
  secondScheduleList: [],
  scheduleDelete: {
    result: false,
  },
  scheduleData: {
    id: '',
    reportType: '',
    title: '',
    status: 0,
    supervisorIds: [''],
    filters: {
      paymentType: 0,
    },
    groupings: [''],
    frequencyType: 0,
    frequencyHour: '',
    frequencyWeekday: [],
    frequencyMonthday: '',
    frequencyQuantity: 0,
    frequencyMonth: '',
    repeatUntil: null,
    dataInterval: 0,
    formats: [],
    createdAt: '',
    updatedAt: '',
  },
  bpeReportList: [],
  bpeTaxVerificationReportList: [],
  paymentRequestList: [],
  incomingByKmValueList: [],
  selectedIncomingTypes: [],
  selectedEmvType: [],
  selectedBrand: [],
  tripControlDetailsResumeReportList: [],
  creditisBySchoolReportList: [],
  usageStatisticsReportList: [],
  selectedEmvStatus: null,
  selectedSchoolCode: null,
  selectedSchoolType: [],
  profileByAgeGroupList: [],
  externalReports: [],
  carList: {},
  isSearchActive: false,
  selectedBpeCode: '',
  selectedBpeNumber: '',
  selectedTicketIdCode: '',
  selectedSaleIdCode: '',
  selectedIncludeBpe: '',
  selectedOrigin: '',
  selectedDestiny: '',
  selectedLineSectionName: '',
  selectedBenefits: [],
  gratuitiesReportList: [],
  employeeTripSapResumeReport: '',
  selectedPaymentDay: new Date(),
  reportDurableClient: null,
  reportDurableStatus: null,
  reportDurableList: [],
  reportDurableCancel: null,
  reportDurableDownload: null,
};

const reducer: Reducer<ReportsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES GET CHART REPORT
    case ReportsTypes.GET_CHART_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chartReportList: INITIAL_STATE.chartReportList,
      };

    case ReportsTypes.GET_CHART_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chartReportList: action.payload.chartReportList,
      };

    case ReportsTypes.GET_CHART_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chartReportList: INITIAL_STATE.chartReportList,
      };
    // CASES GET CHART REPORT
    case ReportsTypes.GRATUITIES_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        gratuitiesReportList: INITIAL_STATE.gratuitiesReportList,
      };

    case ReportsTypes.GRATUITIES_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        gratuitiesReportList: action.payload.gratuitiesReportList,
      };

    case ReportsTypes.GRATUITIES_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        gratuitiesReportList: INITIAL_STATE.gratuitiesReportList,
      };

    // CASES GET INVOICES LIST
    case ReportsTypes.GET_INVOICES_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ...(!action.payload?.isCsvFull && {
          invoicesList: INITIAL_STATE.invoicesList,
        }),
      };

    case ReportsTypes.GET_INVOICES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        ...(!action.payload?.isCsvFull && {
          invoicesList: action.payload.invoicesList,
        }),
        ...(action.payload?.isCsvFull && {
          invoicesListFull: action.payload.invoicesList,
        }),
      };

    case ReportsTypes.GET_INVOICES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        invoicesList: INITIAL_STATE.invoicesList,
      };

    // CASES GET TRANSPORTED PASSENGERS
    case ReportsTypes.GET_TRANSPORTED_PASSENGERS_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportedPassengersList: INITIAL_STATE.transportedPassengersList,
      };

    case ReportsTypes.GET_TRANSPORTED_PASSENGERS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportedPassengersList: action.payload.transportedPassengersList,
      };

    case ReportsTypes.GET_TRANSPORTED_PASSENGERS_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportedPassengersList: INITIAL_STATE.transportedPassengersList,
      };

    // CASES GET KM DRIVED
    case ReportsTypes.GET_KM_DRIVED_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        kmDrivedList: INITIAL_STATE.kmDrivedList,
      };

    case ReportsTypes.GET_KM_DRIVED_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        kmDrivedList: action.payload.kmDrivedList,
      };

    case ReportsTypes.GET_KM_DRIVED_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        kmDrivedList: INITIAL_STATE.kmDrivedList,
      };

    // CASES GET KM DRIVED
    case ReportsTypes.GET_GATE_ENTRY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        gateEntryReportList: INITIAL_STATE.gateEntryReportList,
      };

    case ReportsTypes.GET_GATE_ENTRY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        gateEntryReportList: action.payload.gateEntryReportList,
      };

    case ReportsTypes.GET_GATE_ENTRY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        gateEntryReportList: INITIAL_STATE.gateEntryReportList,
      };

    // CASES GET PASSENGERS BY ORIGIN REPORT
    case ReportsTypes.GET_PASSENGERS_BY_ORIGIN_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        passengersByOriginReportList:
          INITIAL_STATE.passengersByOriginReportList,
      };

    case ReportsTypes.GET_PASSENGERS_BY_ORIGIN_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        passengersByOriginReportList:
          action.payload.passengersByOriginReportList,
      };

    case ReportsTypes.GET_PASSENGERS_BY_ORIGIN_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        passengersByOriginReportList:
          INITIAL_STATE.passengersByOriginReportList,
      };

    // CASES GET CHART LINE REPORT
    case ReportsTypes.LINE_DEMAND_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        lineDemandReportList: INITIAL_STATE.lineDemandReportList,
      };

    case ReportsTypes.LINE_DEMAND_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        lineDemandReportList: action.payload.lineDemandReportList,
      };

    case ReportsTypes.LINE_DEMAND_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        lineDemandReportList: INITIAL_STATE.lineDemandReportList,
      };

    // CASES GET CHART LINE QUANTITY REPORT
    case ReportsTypes.LINE_QUANTITY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        lineQuantityReportList: INITIAL_STATE.lineQuantityReportList,
      };

    case ReportsTypes.LINE_QUANTITY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        lineQuantityReportList: action.payload.lineQuantityReportList,
      };

    case ReportsTypes.LINE_QUANTITY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        lineQuantityReportList: INITIAL_STATE.lineQuantityReportList,
      };

    // CASES GET CHART KM PER DAY
    case ReportsTypes.KM_BY_DAY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        kmByDayReportList: INITIAL_STATE.kmByDayReportList,
      };

    case ReportsTypes.KM_BY_DAY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        kmByDayReportList: action.payload.kmByDayReportList,
      };

    case ReportsTypes.KM_BY_DAY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        kmByDayReportList: INITIAL_STATE.kmByDayReportList,
      };

    // GET_PASSENGERS_AND_VEHICLES_REPORT
    case ReportsTypes.GET_PASSENGERS_AND_VEHICLES_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        passengersAndVehiclesReportList:
          INITIAL_STATE.passengersAndVehiclesReportList,
      };

    case ReportsTypes.GET_PASSENGERS_AND_VEHICLES_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        passengersAndVehiclesReportList:
          action.payload.passengersAndVehiclesReportList,
      };

    case ReportsTypes.GET_PASSENGERS_AND_VEHICLES_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        passengersAndVehiclesReportList:
          INITIAL_STATE.passengersAndVehiclesReportList,
      };

    // GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT
    case ReportsTypes.GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        passengersAndVehiclesByTripReportList:
          INITIAL_STATE.passengersAndVehiclesByTripReportList,
      };

    case ReportsTypes.GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        passengersAndVehiclesByTripReportList:
          action.payload.passengersAndVehiclesByTripReportList,
      };

    case ReportsTypes.GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        passengersAndVehiclesByTripReportList:
          INITIAL_STATE.passengersAndVehiclesByTripReportList,
      };

    // GET_TIMED_OUT_ENTRIES_REPORT
    case ReportsTypes.GET_TIMED_OUT_ENTRIES_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        timedOutEntriesList: INITIAL_STATE.timedOutEntriesList,
      };

    case ReportsTypes.GET_TIMED_OUT_ENTRIES_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        timedOutEntriesList: action.payload.timedOutEntriesList,
      };

    case ReportsTypes.GET_TIMED_OUT_ENTRIES_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        timedOutEntriesList: INITIAL_STATE.timedOutEntriesList,
      };

    // GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT
    case ReportsTypes.GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        pedestriansEntryByTerminalList:
          INITIAL_STATE.pedestriansEntryByTerminalList,
      };

    case ReportsTypes.GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        pedestriansEntryByTerminalList:
          action.payload.pedestriansEntryByTerminalList,
      };

    case ReportsTypes.GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        pedestriansEntryByTerminalList:
          INITIAL_STATE.pedestriansEntryByTerminalList,
      };

    // SET SECCIONED LINES
    case ReportsTypes.SET_SECCIONED_LINES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSeccionedLine: action.payload.selectedSeccionedLine,
      };

    // CASES GET CHART DAILY REPORT
    case ReportsTypes.DAILY_DEMAND_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dailyDemandReportList: INITIAL_STATE.dailyDemandReportList,
      };

    case ReportsTypes.DAILY_DEMAND_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dailyDemandReportList: action.payload.dailyDemandReportList,
      };

    case ReportsTypes.DAILY_DEMAND_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dailyDemandReportList: INITIAL_STATE.dailyDemandReportList,
      };

    // CASES GET TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT
    case ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportedPassengersByTimeFrameList:
          INITIAL_STATE.transportedPassengersByTimeFrameList,
      };

    case ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportedPassengersByTimeFrameList:
          action.payload.transportedPassengersByTimeFrameList,
      };

    case ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportedPassengersByTimeFrameList:
          INITIAL_STATE.transportedPassengersByTimeFrameList,
      };

    // CASES GET TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT
    case ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportedPassengersByTimeFrameByProfileList:
          INITIAL_STATE.transportedPassengersByTimeFrameByProfileList,
      };

    case ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportedPassengersByTimeFrameByProfileList:
          action.payload.transportedPassengersByTimeFrameByProfileList,
      };

    case ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportedPassengersByTimeFrameByProfileList:
          INITIAL_STATE.transportedPassengersByTimeFrameByProfileList,
      };

    // CASES GET CHART DAILY QUANTITY REPORT
    case ReportsTypes.DAILY_QUANTITY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dailyQuantityReportList: INITIAL_STATE.dailyQuantityReportList,
      };

    case ReportsTypes.DAILY_QUANTITY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dailyQuantityReportList: action.payload.dailyQuantityReportList,
      };

    case ReportsTypes.DAILY_QUANTITY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dailyQuantityReportList: INITIAL_STATE.dailyQuantityReportList,
      };

    // CASES GET CHART DAILY QUANTITY REPORT
    case ReportsTypes.DAILY_QUANTITY_SECCIONED_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dailyQuantitySeccionedReportList:
          INITIAL_STATE.dailyQuantitySeccionedReportList,
      };

    case ReportsTypes.DAILY_QUANTITY_SECCIONED_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dailyQuantitySeccionedReportList:
          action.payload.dailyQuantitySeccionedReportList,
      };

    case ReportsTypes.DAILY_QUANTITY_SECCIONED_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dailyQuantitySeccionedReportList:
          INITIAL_STATE.dailyQuantitySeccionedReportList,
      };

    // CASES GET ENTRY REPORT
    case ReportsTypes.GET_CHART_ENTRY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chartEntryReportList: INITIAL_STATE.chartEntryReportList,
      };

    case ReportsTypes.GET_CHART_ENTRY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chartEntryReportList: action.payload.chartEntryReportList,
      };

    case ReportsTypes.GET_CHART_ENTRY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chartEntryReportList: INITIAL_STATE.chartEntryReportList,
      };

    // CASES GET ENTRY REPORT SIMPLIFIED
    case ReportsTypes.GET_CHART_ENTRY_REPORT_SIMPLIFIED_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chartEntryReportSimplifiedList:
          INITIAL_STATE.chartEntryReportSimplifiedList,
      };

    case ReportsTypes.GET_CHART_ENTRY_REPORT_SIMPLIFIED_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chartEntryReportSimplifiedList:
          action.payload.chartEntryReportSimplifiedList,
      };

    case ReportsTypes.GET_CHART_ENTRY_REPORT_SIMPLIFIED_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chartEntryReportSimplifiedList:
          INITIAL_STATE.chartEntryReportSimplifiedList,
      };

    // CASES ENTRY REPORT GROUPED
    case ReportsTypes.ENTRY_REPORT_GROUPED_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        entryReportListGrouped: INITIAL_STATE.entryReportListGrouped,
      };

    case ReportsTypes.ENTRY_REPORT_GROUPED_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        entryReportListGrouped: action.payload.entryReportListGrouped,
      };

    case ReportsTypes.ENTRY_REPORT_GROUPED_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        entryReportListGrouped: INITIAL_STATE.entryReportListGrouped,
      };

    // CASES GET SUPERIOR ACCESS SIMPLIFIED
    case ReportsTypes.GET_SUPERIOR_ACCESS_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        superiorAccessReportList: INITIAL_STATE.superiorAccessReportList,
      };

    case ReportsTypes.GET_SUPERIOR_ACCESS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        superiorAccessReportList: action.payload.superiorAccessReportList,
      };

    case ReportsTypes.GET_SUPERIOR_ACCESS_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        superiorAccessReportList: INITIAL_STATE.superiorAccessReportList,
      };

    // CASES GET CHIPS ENTRY
    case ReportsTypes.CREATE_CHIPS_LIST_ENTRY:
      return {
        ...state,
        loading: false,
        error: false,
        chipsListEntry: action.payload.chipsListEntry,
      };

    // CASES CLEAR CHIPS ENTRY
    case ReportsTypes.CLEAN_CHIPS_LIST_ENTRY:
      return {
        ...state,
        loading: false,
        error: false,
        chipsListEntry: INITIAL_STATE.chipsListEntry,
      };

    // CASES GET CHIPS VALUE
    case ReportsTypes.CREATE_CHIPS_LIST_VALUE:
      return {
        ...state,
        loading: false,
        error: false,
        chipsListValue: action.payload.chipsListValue,
      };

    // CASES CLEAR CHIPS VALUE
    case ReportsTypes.CLEAN_CHIPS_LIST_VALUE:
      return {
        ...state,
        loading: false,
        error: false,
        chipsListValue: INITIAL_STATE.chipsListValue,
      };

    // CASES GET CHIPS LINE
    case ReportsTypes.CREATE_CHIPS_LIST_LINE:
      return {
        ...state,
        loading: false,
        error: false,
        chipsListLine: action.payload.chipsListLine,
      };

    // CASES CLEAR CHIPS LINE
    case ReportsTypes.CLEAN_CHIPS_LIST_LINE:
      return {
        ...state,
        loading: false,
        error: false,
        chipsListLine: INITIAL_STATE.chipsListLine,
      };

    // CASES GET CHIPS HEATMAP
    case ReportsTypes.CREATE_CHIPS_HEATMAP:
      return {
        ...state,
        loading: false,
        error: false,
        chipsHeatmap: action.payload.chipsHeatmap,
      };

    // CASES GET CHIPS FLEET
    case ReportsTypes.CREATE_CHIPS_FLEET:
      return {
        ...state,
        loading: false,
        error: false,
        chipsFleet: action.payload.chipsFleet,
      };

    // CASES GET CHIPS TRAVEL
    case ReportsTypes.CREATE_CHIPS_TRAVEL:
      return {
        ...state,
        loading: false,
        error: false,
        chipsTravel: action.payload.chipsTravel,
      };

    // CASES CLEAR CHIPS TRAVEL
    case ReportsTypes.CLEAN_CHIPS_TRAVEL:
      return {
        ...state,
        loading: false,
        error: false,
        chipsTravel: INITIAL_STATE.chipsTravel,
      };

    // CASES CREATE CHIPS PAYMENT REPORT
    case ReportsTypes.CREATE_CHIPS_PAYMENT_REPORT:
      return {
        ...state,
        loading: false,
        error: false,
        chipsPaymentReport: action.payload.chipsPaymentReport,
      };

    // CASES CLEAR CHIPS PAYMENT REPORT
    case ReportsTypes.CLEAN_CHIPS_PAYMENT_REPORT:
      return {
        ...state,
        loading: false,
        error: false,
        chipsPaymentReport: INITIAL_STATE.chipsPaymentReport,
      };

    // CASES HEATMAP REPORT
    case ReportsTypes.GET_HEATMAP_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        heatmapList: INITIAL_STATE.heatmapList,
      };

    case ReportsTypes.GET_HEATMAP_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        heatmapList: action.payload.heatmapList,
      };

    case ReportsTypes.GET_HEATMAP_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        heatmapList: INITIAL_STATE.heatmapList,
      };

    // CASES PAYMENTE RECEIVE REPORT
    case ReportsTypes.PAYMENT_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        paymentList: INITIAL_STATE.paymentList,
      };

    case ReportsTypes.PAYMENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        paymentList: action.payload.paymentList,
      };

    case ReportsTypes.PAYMENT_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        paymentList: INITIAL_STATE.paymentList,
      };

    // CASES EMTU REPORT
    case ReportsTypes.EMTU_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emtuReportList: INITIAL_STATE.emtuReportList,
      };

    case ReportsTypes.EMTU_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emtuReportList: action.payload.emtuReportList,
      };

    case ReportsTypes.EMTU_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emtuReportList: INITIAL_STATE.emtuReportList,
      };

    // CASES GENERAL REPORT
    case ReportsTypes.GENERAL_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        generalReportList: INITIAL_STATE.generalReportList,
      };

    case ReportsTypes.GENERAL_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        generalReportList: action.payload.generalReportList,
      };

    case ReportsTypes.GENERAL_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        generalReportList: INITIAL_STATE.generalReportList,
      };

    // CASES TRAVEL BY LINE REPORT
    case ReportsTypes.TRAVEL_BY_LINE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        travelByLineReportList: INITIAL_STATE.travelByLineReportList,
      };

    case ReportsTypes.TRAVEL_BY_LINE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        travelByLineReportList: action.payload.travelByLineReportList,
      };

    case ReportsTypes.TRAVEL_BY_LINE_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        travelByLineReportList: INITIAL_STATE.travelByLineReportList,
      };

    // SET INVOICE STATUS
    case ReportsTypes.SET_SELECTED_INVOICE_STATUS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedInvoiceStatus: action.payload.selectedInvoiceStatus,
      };

    // SET SELECTED CARS
    case ReportsTypes.SET_SELECTED_CARS_ID:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCarsId: action.payload.selectedCarsId,
      };
    case ReportsTypes.SET_SELECTED_CARS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCars: action.payload.selectedCars,
      };

    case ReportsTypes.SET_SELECTED_COMPANIES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCompanies: action.payload.selectedCompanies,
      };
    // SET SELECTED Terminals

    case ReportsTypes.SET_SELECTED_TERMINALS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTerminals: action.payload.selectedTerminals,
      };
    // SET SELECTED PROFILES
    case ReportsTypes.SET_SELECTED_PROFILES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedProfiles: action.payload.selectedProfiles,
      };

    // SET SELECTED PAYMENTS
    case ReportsTypes.SET_SELECTED_PAYMENTS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedPayments: action.payload.selectedPayments,
      };

    // SET SELECTED PAYMENT STATUS
    case ReportsTypes.SET_SELECTED_PAYMENT_STATUS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedPaymentStatus: action.payload.selectedPaymentStatus,
      };

    // SET SELECTED OPERATION TYPE
    case ReportsTypes.SET_SELECTED_OPERATION_TYPE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedOperationType: action.payload.selectedOperationType,
      };

    // SET SELECTED QRCODES
    case ReportsTypes.SET_SELECTED_QRCODES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedQRCodes: action.payload.selectedQRCodes,
      };

    // SET SELECTED LINES
    case ReportsTypes.SET_SELECTED_LINES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedLines: action.payload.selectedLines,
      };

    // SET SELECTED Benefits
    case ReportsTypes.SET_SELECTED_BENEFIT:
      return {
        ...state,
        loading: false,
        error: false,
        selectedBenefits: action.payload.selectedBenefits,
      };

    // SET SELECTED SCHOOLS
    case ReportsTypes.SET_SELECTED_SCHOOLS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSchools: action.payload.selectedSchools,
      };

    // SET SELECTED LINES
    case ReportsTypes.SET_SELECTED_EMVTYPE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedEmvType: action.payload.selectedEmvType,
      };
    // SET SELECTED BRAND
    case ReportsTypes.SET_SELECTED_BRAND:
      return {
        ...state,
        loading: false,
        error: false,
        selectedBrand: action.payload.selectedBrand,
      };

    // SET SELECTED SECTION LINES
    case ReportsTypes.SET_SELECTED_SECTION_LINES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSectionLines: action.payload.selectedSectionLines,
      };

    // SET SELECTED FILE_NAME
    case ReportsTypes.SET_SELECTED_FILENAME:
      return {
        ...state,
        loading: false,
        error: false,
        filenameSelected: action.payload.filenameSelected,
      };

    // SET SELECTED EMPLOYEES
    case ReportsTypes.SET_SELECTED_EMPLOYEES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedEmployees: action.payload.selectedEmployees,
      };

    // SET SELECTED EMPLOYEES
    case ReportsTypes.SET_SELECTED_DRIVER_REGISTRY:
      return {
        ...state,
        loading: false,
        error: false,
        selectedDriverRegistry: action.payload.selectedDriverRegistry,
      };

    // SET SELECTED START DATE
    case ReportsTypes.SET_SELECTED_START_DATE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedStartDate: action.payload.selectedStartDate,
      };

    // CASES SELECTED END DATE
    case ReportsTypes.SET_SELECTED_END_DATE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedEndDate: action.payload.selectedEndDate,
      };

    // CASES SELECTED END DATE
    case ReportsTypes.SET_SELECTED_STARTED_AT_DATE:
      return {
        ...state,
        loading: false,
        error: false,
        startedAt: action.payload.startedAt,
      };

    // CASES SELECTED PROFILE EXPIRATION
    case ReportsTypes.SET_SELECTED_PROFILE_EXPIRATION:
      return {
        ...state,
        loading: false,
        error: false,
        selectedProfileExpiration: action.payload.selectedProfileExpiration,
      };

    // CASES SELECTED NUMBER OF DAYS
    case ReportsTypes.SET_SELECTED_NUMBER_OF_DAYS:
      return {
        ...state,
        loading: false,
        error: false,
        numberOfDays: action.payload.numberOfDays,
      };

    // SET SELECTED RECEIVE PAYMENTS
    case ReportsTypes.SET_SELECTED_RECEIVE_PAYMENTS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedReceivePayments: action.payload.selectedReceivePayments,
      };

    // SET SELECTED TRIP STATUS
    case ReportsTypes.SET_SELECTED_TRIP_STATUS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTripStatus: action.payload.selectedTripStatus,
      };

    // SET SELECTED TRIP OR TICKET
    case ReportsTypes.SET_SELECTED_TRIP_OR_TICKET:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTripOrTicket: action.payload.selectedTripOrTicket,
      };

    // SET SELECTED SUPERVISOR
    case ReportsTypes.SET_SELECTED_SUPERVISOR:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSupervisors: action.payload.selectedSupervisors,
      };

    // SET SELECTED DBDS
    case ReportsTypes.SET_SELECTED_DBD:
      return {
        ...state,
        loading: false,
        error: false,
        selectedDbds: action.payload.selectedDbds,
      };

    // SET SELECTED TOKEN STATUS
    case ReportsTypes.SET_SELECTED_TOKEN_STATUS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTokenStatus: action.payload.selectedTokenStatus,
      };

    // SET SELECTED CREDIT TYPE
    case ReportsTypes.SET_SELECTED_CREDIT_TYPE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCreditType: action.payload.selectedCreditType,
      };

    // SET SELECTED NAME
    case ReportsTypes.SET_SELECTED_NAME:
      return {
        ...state,
        loading: false,
        error: false,
        selectedName: action.payload.selectedName,
      };

    // SET SELECTED BPE_CODE
    case ReportsTypes.SET_SELECTED_BPE_CODE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedBpeCode: action.payload.selectedBpeCode,
      };

    // SET SELECTED BPE NUMBER
    case ReportsTypes.SET_SELECTED_BPE_NUMBER:
      return {
        ...state,
        loading: false,
        error: false,
        selectedBpeNumber: action.payload.selectedBpeNumber,
      };

    // SET SELECTED TICKET ID CODE
    case ReportsTypes.SET_SELECTED_TICKET_ID_CODE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTicketIdCode: action.payload.selectedTicketIdCode,
      };

    // SET SELECTED SALE ID CODE
    case ReportsTypes.SET_SELECTED_SALE_ID_CODE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSaleIdCode: action.payload.selectedSaleIdCode,
      };
    // SET SELECTED BPE NUMBER
    case ReportsTypes.SET_SELECTED_ORIGIN:
      return {
        ...state,
        loading: false,
        error: false,
        selectedOrigin: action.payload.selectedOrigin,
      };
    // SET SELECTED BPE NUMBER
    case ReportsTypes.SET_SELECTED_DESTINY:
      return {
        ...state,
        loading: false,
        error: false,
        selectedDestiny: action.payload.selectedDestiny,
      };

    // SET SELECTED INCLUDE BPE
    case ReportsTypes.SET_SELECTED_INCLUDE_BPE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedIncludeBpe: action.payload.selectedIncludeBpe,
      };

    // SET SELECTED SET SELECTED LINE SECTION NAME
    case ReportsTypes.SET_SELECTED_LINE_SECTION_NAME:
      return {
        ...state,
        loading: false,
        error: false,
        selectedLineSectionName: action.payload.selectedLineSectionName,
      };

    // SET SELECTED QUANTITY
    case ReportsTypes.SET_SELECTED_QUANTITY:
      return {
        ...state,
        loading: false,
        error: false,
        selectedQuantity: action.payload.selectedQuantity,
      };

    // SET SELECTED DOCUMENT
    case ReportsTypes.SET_SELECTED_DOCUMENT:
      return {
        ...state,
        loading: false,
        error: false,
        selectedDocument: action.payload.selectedDocument,
      };

    // SET SELECTED EMAIL
    case ReportsTypes.SET_SELECTED_EMAIL:
      return {
        ...state,
        loading: false,
        error: false,
        selectedEmail: action.payload.selectedEmail,
      };

    // SET SELECTED TRANSPORT CARD
    case ReportsTypes.SET_SELECTED_TRANSPORT_CARD:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTransportCard: action.payload.selectedTransportCard,
      };

    // SET SELECTED DEVICE
    case ReportsTypes.SET_SELECTED_DEVICE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedDevice: action.payload.selectedDevice,
      };

    // SET SELECTED CREDIT CARD
    case ReportsTypes.SET_SELECTED_CREDIT_CARD:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCreditCard: action.payload.selectedCreditCard,
      };

    // SET SELECTED CNPJ
    case ReportsTypes.SET_SELECTED_CNPJ:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCNPJ: action.payload.selectedCNPJ,
      };

    // SET SELECTED NSU
    case ReportsTypes.SET_SELECTED_NSU:
      return {
        ...state,
        loading: false,
        error: false,
        selectedNSU: action.payload.selectedNSU,
      };

    // SET SELECTED PHONE
    case ReportsTypes.SET_SELECTED_PHONE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedPhone: action.payload.selectedPhone,
      };

    // SET_HISTORY_FILTER
    case ReportsTypes.SET_HISTORY_FILTER:
      return {
        ...state,
        loading: false,
        error: false,
        history: action.payload.history,
      };

    // SET SELECTED LICENSE
    case ReportsTypes.SET_SELECTED_LICENSE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedLicense: action.payload.selectedLicense,
      };

    // SET SELECTED PREFIX
    case ReportsTypes.SET_SELECTED_PREFIX:
      return {
        ...state,
        loading: false,
        error: false,
        selectedPrefix: action.payload.selectedPrefix,
      };

    // SET SELECTED CAR MODEL
    case ReportsTypes.SET_SELECTED_CAR_MODEL:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCarModel: action.payload.selectedCarModel,
      };

    // SET SELECTED AGE
    case ReportsTypes.SET_SELECTED_AGE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedAge: action.payload.selectedAge,
      };

    // SET SELECTED SIT CAPACITY
    case ReportsTypes.SET_SELECTED_SIT_CAPACITY:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSitCapacity: action.payload.selectedSitCapacity,
      };

    // SET SELECTED FOOT CAPACITY
    case ReportsTypes.SET_SELECTED_FOOT_CAPACITY:
      return {
        ...state,
        loading: false,
        error: false,
        selectedFootCapacity: action.payload.selectedFootCapacity,
      };

    // SET SELECTED ACCESSIBLE
    case ReportsTypes.SET_SELECTED_ACCESSIBLE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedAccessible: action.payload.selectedAccessible,
      };

    // SET SELECTED AIR CONDITIONED
    case ReportsTypes.SET_SELECTED_AIR_CONDITIONED:
      return {
        ...state,
        loading: false,
        error: false,
        selectedAirConditioned: action.payload.selectedAirConditioned,
      };

    // SET SELECTED TICKETER
    case ReportsTypes.SET_SELECTED_TICKETER:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTicketer: action.payload.selectedTicketer,
      };

    // SET SELECTED REGISTER
    case ReportsTypes.SET_SELECTED_REGISTRY:
      return {
        ...state,
        loading: false,
        error: false,
        selectedRegistry: action.payload.selectedRegistry,
      };

    // SET SELECTED LICENSE NUMBER
    case ReportsTypes.SET_SELECTED_LICENSE_NUMBER:
      return {
        ...state,
        loading: false,
        error: false,
        selectedLicenseNumber: action.payload.selectedLicenseNumber,
      };

    // SET SELECTED NUMBER
    case ReportsTypes.SET_SELECTED_NUMBER:
      return {
        ...state,
        loading: false,
        error: false,
        selectedNumber: action.payload.selectedNumber,
      };

    // SET SELECTED CARD NUMBER
    case ReportsTypes.SET_SELECTED_CARD_NUMBER:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCardNumber: action.payload.selectedCardNumber,
      };

    // SET SELECTED LOT
    case ReportsTypes.SET_SELECTED_LOT:
      return {
        ...state,
        loading: false,
        error: false,
        selectedLot: action.payload.selectedLot,
      };

    // SET SELECTED CARD TYPE
    case ReportsTypes.SET_SELECTED_CARD_TYPE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCardType: action.payload.selectedCardType,
      };

    // SET SELECTED CARD STATUS
    case ReportsTypes.SET_SELECTED_CARD_STATUS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCardStatus: action.payload.selectedCardStatus,
      };

    // SET SELECTED CARD STATUS
    case ReportsTypes.SET_SELECTED_COVERED:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCovered: action.payload.selectedCovered,
      };

    // SET SELECTED BUS BAY
    case ReportsTypes.SET_SELECTED_BUS_BAY:
      return {
        ...state,
        loading: false,
        error: false,
        selectedBusBay: action.payload.selectedBusBay,
      };

    // SET SELECTED SPECIAL BUS STOP
    case ReportsTypes.SET_SELECTED_SPECIAL_BUS_STOP:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSpecialBusStop: action.payload.selectedSpecialBusStop,
      };

    // SET SELECTED RESPONSIBLE
    case ReportsTypes.SET_SELECTED_RESPONSIBLE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedResponsible: action.payload.selectedResponsible,
      };

    // SET SELECTED TERMINAL NAME
    case ReportsTypes.SET_SELECTED_TERMINAL_NAME:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTerminalName: action.payload.selectedTerminalName,
      };

    // SET SELECTED BLOCK NAME
    case ReportsTypes.SET_SELECTED_BLOCK_NAME:
      return {
        ...state,
        loading: false,
        error: false,
        selectedBlockName: action.payload.selectedBlockName,
      };

    // SET SELECTED TOTAL LINES
    case ReportsTypes.SET_SELECTED_TOTAL_LINES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTotalLines: action.payload.selectedTotalLines,
      };

    // SET SELECTED TARIFF
    case ReportsTypes.SET_SELECTED_TARIFF:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTariff: action.payload.selectedTariff,
      };

    // SET SELECTED TITLE
    case ReportsTypes.SET_SELECTED_TITLE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedTitle: action.payload.selectedTitle,
      };

    // SET SELECTED LINE MODEL
    case ReportsTypes.SET_SELECTED_LINE_MODES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedLineModes: action.payload.selectedLineModes,
      };

    // SET SELECTED LINE MODEL
    case ReportsTypes.SET_SELECTED_LINE_MODEL:
      return {
        ...state,
        loading: false,
        error: false,
        selectedLineModel: action.payload.selectedLineModel,
      };

    // SET SELECTED PROFILE STATUS
    case ReportsTypes.SET_SELECTED_PROFILE_STATUS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedProfileStatus: action.payload.selectedProfileStatus,
      };

    // SET SELECTED STATUS
    case ReportsTypes.SET_SELECTED_STATUS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedStatus: action.payload.selectedStatus,
      };

    // SET FILTERED ITEMS
    case ReportsTypes.SET_FILTERED_ITEMS:
      return {
        ...state,
        loading: false,
        error: false,
        filterItems: action.payload.filterItems,
      };

    // SET CSV FULL IS CHECKED
    case ReportsTypes.SET_CSV_FULL_IS_CHECKED:
      return {
        ...state,
        loading: false,
        error: false,
        csvFullIsChecked: action.payload.csvFullIsChecked,
      };

    // SET SELECTED SELLING POINT
    case ReportsTypes.SET_SELECTED_SELLING_POINT:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSellingPoint: action.payload.selectedSellingPoint,
      };

    // SET SELECTED SELLING TERMINAL
    case ReportsTypes.SET_SELECTED_SELLING_TERMINAL:
      return {
        ...state,
        loading: false,
        error: false,
        selectedSellingTerminal: action.payload.selectedSellingTerminal,
      };

    // SET SELECTED DATE TYPE
    case ReportsTypes.SET_SELECTED_DATE_TYPE:
      return {
        ...state,
        loading: false,
        error: false,
        dateType: action.payload.selectedDateType,
      };

    // SET SELECTED BPe DATE TYPE
    case ReportsTypes.SET_SELECTED_DATE_TYPE_BPE:
      return {
        ...state,
        loading: false,
        error: false,
        dateTypeBPe: action.payload.selectedDateTypeBPe,
      };

    // SET SELECTED LINE TYPE
    case ReportsTypes.SET_SELECTED_LINE_TYPE:
      return {
        ...state,
        loading: false,
        error: false,
        lineType: action.payload.selectedLineType,
      };

    // SET_STATUS_DEVICE_RELEASE
    case ReportsTypes.SET_STATUS_DEVICE_RELEASE:
      return {
        ...state,
        loading: false,
        error: false,
        statusDeviceRelease: action.payload.selectedStatusDeviceRelease,
      };

    // CASES GET SHEDULE LIST
    case ReportsTypes.SHEDULE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        scheduleList: INITIAL_STATE.scheduleList,
      };

    case ReportsTypes.SHEDULE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        scheduleList: action.payload.scheduleList,
      };

    case ReportsTypes.SHEDULE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        scheduleList: INITIAL_STATE.scheduleList,
      };

    case ReportsTypes.SECOND_SHEDULE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        secondScheduleList: INITIAL_STATE.secondScheduleList,
      };
    case ReportsTypes.SECOND_SHEDULE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        secondScheduleList: action.payload.secondScheduleList,
      };

    case ReportsTypes.SECOND_SHEDULE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        secondScheduleList: INITIAL_STATE.secondScheduleList,
      };

    // CASES GET SHEDULE
    case ReportsTypes.SHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        scheduleData: action.payload.scheduleData,
      };

    // CASES SHEDULE DELETE
    case ReportsTypes.SHEDULE_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        scheduleDelete: INITIAL_STATE.scheduleDelete,
      };

    case ReportsTypes.SHEDULE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        scheduleDelete: action.payload.scheduleDelete,
      };

    case ReportsTypes.SHEDULE_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        scheduleDelete: INITIAL_STATE.scheduleDelete,
      };

    // CASES SHEDULE CREATE
    case ReportsTypes.SHEDULE_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        scheduleData: INITIAL_STATE.scheduleData,
      };

    case ReportsTypes.SHEDULE_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        scheduleData: action.payload.scheduleData,
      };

    case ReportsTypes.SHEDULE_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        scheduleData: INITIAL_STATE.scheduleData,
      };

    // CASES GET PAYMENT REQUEST LIST
    case ReportsTypes.PAYMENT_REQUEST_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        paymentRequestList: INITIAL_STATE.paymentRequestList,
      };

    case ReportsTypes.PAYMENT_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        paymentRequestList: action.payload.paymentRequestList,
      };

    case ReportsTypes.PAYMENT_REQUEST_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        paymentRequestList: INITIAL_STATE.paymentRequestList,
      };

    // CASES SHIPMENT BY LINE
    case ReportsTypes.SHIPMENT_BY_LINE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        shipmentLineEntries: INITIAL_STATE.shipmentLineEntries,
      };

    case ReportsTypes.SHIPMENT_BY_LINE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        shipmentLineEntries: action.payload.shipmentLineEntries,
      };

    case ReportsTypes.SHIPMENT_BY_LINE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        shipmentLineEntries: INITIAL_STATE.shipmentLineEntries,
      };

    // CASES GET INCOMING BY KM VALUE
    case ReportsTypes.INCOMING_BY_KM_VALUE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        incomingByKmValueList: INITIAL_STATE.incomingByKmValueList,
      };

    case ReportsTypes.INCOMING_BY_KM_VALUE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        incomingByKmValueList: action.payload.incomingByKmValueList,
      };

    case ReportsTypes.INCOMING_BY_KM_VALUE_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        incomingByKmValueList: INITIAL_STATE.incomingByKmValueList,
      };

    // SET SELECTED INCOMING TYPES
    case ReportsTypes.SET_SELECTED_INCOMING_TYPES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedIncomingTypes: action.payload.selectedIncomingTypes,
      };

    // CASES GET TRIP COLLECTION
    case ReportsTypes.TRIP_COLLECTION_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tripeCollectionReportList: INITIAL_STATE.tripeCollectionReportList,
      };

    case ReportsTypes.TRIP_COLLECTION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripeCollectionReportList: action.payload.tripeCollectionReportList,
      };

    case ReportsTypes.TRIP_COLLECTION_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripeCollectionReportList: INITIAL_STATE.tripeCollectionReportList,
      };

    // CASES LIST EMV
    case ReportsTypes.EMV_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emvReportList: INITIAL_STATE.emvReportList,
      };

    case ReportsTypes.EMV_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emvReportList: action.payload.emvReportList,
      };

    case ReportsTypes.EMV_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emvReportList: INITIAL_STATE.emvReportList,
      };

    // CASES BPE REPORT REQUEST
    case ReportsTypes.BPE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bpeReportList: INITIAL_STATE.bpeReportList,
      };

    case ReportsTypes.BPE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bpeReportList: action.payload.bpeReportList,
      };

    case ReportsTypes.BPE_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bpeReportList: INITIAL_STATE.bpeReportList,
      };

    // CASES BPE TAX VERIFICATION REPORT REQUEST
    case ReportsTypes.BPE_TAX_VERIFICATION_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bpeTaxVerificationReportList:
          INITIAL_STATE.bpeTaxVerificationReportList,
      };

    case ReportsTypes.BPE_TAX_VERIFICATION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bpeTaxVerificationReportList:
          action.payload.bpeTaxVerificationReportList,
      };

    case ReportsTypes.BPE_TAX_VERIFICATION_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bpeTaxVerificationReportList:
          INITIAL_STATE.bpeTaxVerificationReportList,
      };

    // CASES LIST EMV DECLINED_BY_REASON
    case ReportsTypes.EMV_DECLINED_BY_REASON_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emvDeclinedByReasonReportList:
          INITIAL_STATE.emvDeclinedByReasonReportList,
      };

    case ReportsTypes.EMV_DECLINED_BY_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emvDeclinedByReasonReportList:
          action.payload.emvDeclinedByReasonReportList,
      };

    case ReportsTypes.EMV_DECLINED_BY_REASON_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emvDeclinedByReasonReportList:
          INITIAL_STATE.emvDeclinedByReasonReportList,
      };

    // CASES LIST EMV APPROVED_BY_BRAND
    case ReportsTypes.EMV_APPROVED_BY_BRAND_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emvApprovedByBrandReportList:
          INITIAL_STATE.emvApprovedByBrandReportList,
      };

    case ReportsTypes.EMV_APPROVED_BY_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emvApprovedByBrandReportList:
          action.payload.emvApprovedByBrandReportList,
      };

    case ReportsTypes.EMV_APPROVED_BY_BRAND_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emvApprovedByBrandReportList:
          INITIAL_STATE.emvApprovedByBrandReportList,
      };

    // CASES LIST EMV APPROVED_BY_DEBT_RECOVERY
    case ReportsTypes.EMV_APPROVED_BY_DEBT_RECOVERY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emvApprovedByDebtRecoveryReportList:
          INITIAL_STATE.emvApprovedByDebtRecoveryReportList,
      };

    case ReportsTypes.EMV_APPROVED_BY_DEBT_RECOVERY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emvApprovedByDebtRecoveryReportList:
          action.payload.emvApprovedByDebtRecoveryReportList,
      };

    case ReportsTypes.EMV_APPROVED_BY_DEBT_RECOVERY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emvApprovedByDebtRecoveryReportList:
          INITIAL_STATE.emvApprovedByDebtRecoveryReportList,
      };

    // CASES LIST EMV APPROVED_BY_ATTEMPTS
    case ReportsTypes.EMV_APPROVED_BY_ATTEMPTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emvApprovedByAttemptsReportList:
          INITIAL_STATE.emvApprovedByAttemptsReportList,
      };

    case ReportsTypes.EMV_APPROVED_BY_ATTEMPTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emvApprovedByAttemptsReportList:
          action.payload.emvApprovedByAttemptsReportList,
      };

    case ReportsTypes.EMV_APPROVED_BY_ATTEMPTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emvApprovedByAttemptsReportList:
          INITIAL_STATE.emvApprovedByAttemptsReportList,
      };

    // CASES LIST EMV APPROVED_FIRST_TAP_BY_BRAND
    case ReportsTypes.EMV_APPROVED_FIRST_TAP_BY_BRAND_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emvApprovedByFirstTapByBrandReportList:
          INITIAL_STATE.emvApprovedByFirstTapByBrandReportList,
      };

    case ReportsTypes.EMV_APPROVED_FIRST_TAP_BY_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emvApprovedByFirstTapByBrandReportList:
          action.payload.emvApprovedByFirstTapByBrandReportList,
      };

    case ReportsTypes.EMV_APPROVED_FIRST_TAP_BY_BRAND_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emvApprovedByFirstTapByBrandReportList:
          INITIAL_STATE.emvApprovedByFirstTapByBrandReportList,
      };

    // CASES LIST EMV_ENTRY_GET
    case ReportsTypes.EMV_ENTRY_GET_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emvEntryGetList: INITIAL_STATE.emvEntryGetList,
      };

    case ReportsTypes.EMV_ENTRY_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emvEntryGetList: action.payload.emvEntryGetList,
      };

    case ReportsTypes.EMV_ENTRY_GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emvEntryGetList: INITIAL_STATE.emvEntryGetList,
      };

    // CASES LIST EMV_ENTRY_GET_HISTORY
    case ReportsTypes.EMV_ENTRY_GET_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        emvEntryGetHistoryList: INITIAL_STATE.emvEntryGetHistoryList,
      };

    case ReportsTypes.EMV_ENTRY_GET_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        emvEntryGetHistoryList: action.payload.emvEntryGetHistoryList,
      };

    case ReportsTypes.EMV_ENTRY_GET_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        emvEntryGetHistoryList: INITIAL_STATE.emvEntryGetHistoryList,
      };

    // CASES LIST ORDERS_BY_SCHOOL_REPORT_REQUEST
    case ReportsTypes.ORDERS_BY_SCHOOL_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ordersBySchoolsList: INITIAL_STATE.ordersBySchoolsList,
      };

    case ReportsTypes.ORDERS_BY_SCHOOL_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ordersBySchoolsList: action.payload.ordersBySchoolsList,
      };

    case ReportsTypes.ORDERS_BY_SCHOOL_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        ordersBySchoolsList: INITIAL_STATE.ordersBySchoolsList,
      };

    // CASES LIST STUDENT_CARDS_REPORT_REQUEST
    case ReportsTypes.STUDENT_CARDS_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        studentCardsList: INITIAL_STATE.studentCardsList,
      };

    case ReportsTypes.STUDENT_CARDS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        studentCardsList: action.payload.studentCardsList,
      };

    case ReportsTypes.STUDENT_CARDS_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        studentCardsList: INITIAL_STATE.studentCardsList,
      };

    // CASES GET TRIP CONTROL DETAIL RESUME REPORT REQUEST
    case ReportsTypes.TRIP_CONTROL_DETAIL_RESUME_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tripControlDetailsResumeReportList:
          INITIAL_STATE.tripControlDetailsResumeReportList,
      };

    case ReportsTypes.TRIP_CONTROL_DETAIL_RESUME_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripControlDetailsResumeReportList:
          action.payload.tripControlDetailsResumeReportList,
      };

    case ReportsTypes.TRIP_CONTROL_DETAIL_RESUME_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripControlDetailsResumeReportList:
          INITIAL_STATE.tripControlDetailsResumeReportList,
      };

    // SET SELECTED EMV STATUS
    case ReportsTypes.SET_SELECTED_EMV_STATUS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedEmvStatus: action.payload.selectedEmvStatus,
      };

    // CASES LIST PROFILE BY AGE GROUP REPORT REQUEST
    case ReportsTypes.PROFILE_BY_AGE_ROUPE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        profileByAgeGroupList: INITIAL_STATE.profileByAgeGroupList,
      };

    case ReportsTypes.PROFILE_BY_AGE_ROUPE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        profileByAgeGroupList: action.payload.profileByAgeGroupList,
      };

    case ReportsTypes.PROFILE_BY_AGE_ROUPE_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        profileByAgeGroupList: INITIAL_STATE.profileByAgeGroupList,
      };

    // CASES LIST PROFILE BY CREDITIS_BY_SCHOOL_REPORT_REQUEST
    case ReportsTypes.CREDITIS_BY_SCHOOL_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        creditisBySchoolReportList: INITIAL_STATE.creditisBySchoolReportList,
      };

    case ReportsTypes.CREDITIS_BY_SCHOOL_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        creditisBySchoolReportList: action.payload.creditisBySchoolReportList,
      };

    case ReportsTypes.CREDITIS_BY_SCHOOL_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        creditisBySchoolReportList: INITIAL_STATE.creditisBySchoolReportList,
      };

    // CASES SET SELECTED SHOOL CODE
    case ReportsTypes.SET_SELECTED_SHOOL_CODE:
      return {
        ...state,
        loading: true,
        error: false,
        selectedSchoolCode: action.payload.selectedSchoolCode,
      };

    // CASES SET SELECTED SHOOL CODE
    case ReportsTypes.SET_SELECTED_SHOOL_TYPE:
      return {
        ...state,
        loading: true,
        error: false,
        selectedSchoolType: action.payload.selectedSchoolType,
      };

    // CASES LIST PROFILE BY USAGE_STATISTICS_REPORT_REQUEST
    case ReportsTypes.USAGE_STATISTICS_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        usageStatisticsReportList: INITIAL_STATE.usageStatisticsReportList,
      };

    case ReportsTypes.USAGE_STATISTICS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        usageStatisticsReportList: action.payload.usageStatisticsReportList,
      };

    case ReportsTypes.USAGE_STATISTICS_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        usageStatisticsReportList: INITIAL_STATE.usageStatisticsReportList,
      };

    // CASES LIST CAR REPORT REQUEST
    case ReportsTypes.LIST_CAR_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case ReportsTypes.LIST_CAR_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        carList: action.payload.carList,
      };

    case ReportsTypes.LIST_CAR_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case ReportsTypes.SET_IS_SEARCH_ACTIVE:
      return {
        ...state,
        isSearchActive: action.payload,
      };

    // SET SELECTED COMPANIES
    case ReportsTypes.SET_SELECTED_COMPANIES:
      return {
        ...state,
        loading: false,
        error: false,
        selectedCompanies: action.payload.selectedCompanies,
      };

    // EXTERNAL REPORTS
    case ReportsTypes.EXTERNAL_REPORTS:
      return {
        ...state,
        loading: false,
        error: false,
        externalReports: action.payload.externalReports,
      };

    // CASES EMPLOYEE TRIP SAP RESUME REPORT
    case ReportsTypes.EMPLOYEE_TRIP_SAP_RESUME_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeeTripSapResumeReport: INITIAL_STATE.employeeTripSapResumeReport,
      };

    case ReportsTypes.EMPLOYEE_TRIP_SAP_RESUME_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeTripSapResumeReport: action.payload.employeeTripSapResumeReport,
      };

    case ReportsTypes.EMPLOYEE_TRIP_SAP_RESUME_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeeTripSapResumeReport: INITIAL_STATE.employeeTripSapResumeReport,
      };

    // SET SELECTED PAYMENT DATE
    case ReportsTypes.SET_SELECTED_PAYMENT_DAY:
      return {
        ...state,
        loading: false,
        error: false,
        selectedPaymentDay: action.payload.selectedPaymentDay,
      };

    // CASES REPORT DURABLE CLIENT
    case ReportsTypes.REPORT_DURABLE_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        reportDurableClient: INITIAL_STATE.reportDurableClient,
      };

    case ReportsTypes.REPORT_DURABLE_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        reportDurableClient: action.payload,
      };

    case ReportsTypes.REPORT_DURABLE_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        reportDurableClient: INITIAL_STATE.reportDurableClient,
      };

    // CASES REPORT DURABLE STATUS
    case ReportsTypes.REPORT_DURABLE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        reportDurableStatus: INITIAL_STATE.reportDurableStatus,
      };

    case ReportsTypes.REPORT_DURABLE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        reportDurableStatus: action.payload.durableStatus,
      };

    case ReportsTypes.REPORT_DURABLE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        reportDurableStatus: INITIAL_STATE.reportDurableStatus,
      };

    // CASES REPORT DURABLE LIST
    case ReportsTypes.REPORT_DURABLE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        reportDurableList: INITIAL_STATE.reportDurableList,
      };

    case ReportsTypes.REPORT_DURABLE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        reportDurableList: action.payload.durableList,
      };

    case ReportsTypes.REPORT_DURABLE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        reportDurableList: INITIAL_STATE.reportDurableList,
      };

    // CASES REPORT DURABLE CANCEL
    case ReportsTypes.REPORT_DURABLE_CANCEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        reportDurableCancel: INITIAL_STATE.reportDurableCancel,
      };

    case ReportsTypes.REPORT_DURABLE_CANCEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        reportDurableCancel: action.payload.durableCancel,
        reportDurableList: state.reportDurableList.map((item) =>
          item.id === action.payload.durableCancel.id
            ? { ...item, status: action.payload.durableCancel.status }
            : item,
        ),
      };

    case ReportsTypes.REPORT_DURABLE_CANCEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        reportDurableCancel: INITIAL_STATE.reportDurableCancel,
      };

    // CASES REPORT DURABLE DOWNLOAD
    case ReportsTypes.REPORT_DURABLE_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        reportDurableDownload: INITIAL_STATE.reportDurableDownload,
      };

    case ReportsTypes.REPORT_DURABLE_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case ReportsTypes.REPORT_DURABLE_DOWNLOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        reportDurableDownload: INITIAL_STATE.reportDurableDownload,
      };

    default:
      return state;
  }
};

export default reducer;
